import type { ReactNode } from "react";
import styled from "styled-components";

const Field = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 0;

	label {
		font-size: 14px;
		line-height: 24px;
		color: #707070;
	}
`;

const InlineError = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	margin-top: 2px;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	letter-spacing: 0;
	color: #e43838;
`;

const RequiredMark = styled.span`
	color: #d80027;
`;

export interface FormFieldProps {
	label: ReactNode;
	htmlFor?: string;
	labelId?: string;
	error?: ReactNode;
	required?: boolean;
	children: ReactNode;
	className?: string;
}

/** A labelled form control wrapper with an inline, layout-stable validation message. */
export const FormField = ({
	label,
	htmlFor,
	labelId,
	error,
	required = false,
	children,
	className,
}: FormFieldProps) => (
	<Field className={className}>
		<label htmlFor={htmlFor} id={labelId}>
			{label}
			{required && <RequiredMark aria-hidden="true"> *</RequiredMark>}
		</label>
		{children}
		{error && <InlineError role="alert">{error}</InlineError>}
	</Field>
);
